module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "main-menu__item has-dropright"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-menu__item__dropright-menu"
  }, [_c('div', {
    staticClass: "main-menu__item__dropright-menu__container"
  }, [_c('div', {
    staticClass: "main-menu__item__dropright-menu__section"
  }, [_c('h4', {
    staticClass: "main-menu__item__dropright-menu__title"
  }, [_vm._v("Цены")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Prices'
      }
    }
  }, [_vm._v("Стоимость перевозки")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Extrasizes'
      }
    }
  }, [_vm._v("Негабаритный груз")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'PaymentMethods'
      }
    }
  }, [_vm._v("Способы оплаты")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Cities'
      }
    }
  }, [_vm._v("Населённые пункты")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Zones'
      }
    }
  }, [_vm._v("Направления")])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-menu__item__dropright-menu__section"
  }, [_c('h4', {
    staticClass: "main-menu__item__dropright-menu__title"
  }, [_vm._v("Услуги")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'DoomPrices'
      }
    }
  }, [_vm._v("Обрешётка")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'LuwPrices'
      }
    }
  }, [_vm._v("Погрузочно-разгрузочные работы")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ManipulatorPrices'
      }
    }
  }, [_vm._v("Услуги манипулятора")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'AirportPrices'
      }
    }
  }, [_vm._v("Представление интересов в аэропорту")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'StoragePrices'
      }
    }
  }, [_vm._v("Сверхнормативное хранение")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ForwardingPrices'
      }
    }
  }, [_vm._v("Экспедирование")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'AdditionalServices'
      }
    }
  }, [_vm._v("Дополнительные услуги")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("Цены")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17cb8b40","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/menus/SettingsMenu.vue
// module id = 1047
// module chunks = 0